/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { GetincidentReportsCsvMutation, GetincidentReportsCsvMutationVariables } from "@models/graphql";

const defaultGetIncidentReportCsvOptions: MutationHookOptions<GetincidentReportsCsvMutation, GetincidentReportsCsvMutationVariables> = {};

export const useGetIncidentReportCsv = (
    options?: MutationHookOptions<GetincidentReportsCsvMutation, GetincidentReportsCsvMutationVariables>
) => {
    const [mutation, { data, loading, error }] = useMutation<GetincidentReportsCsvMutation, GetincidentReportsCsvMutationVariables>(
        GraphQLDocuments.getIncidentReportCsv
    );

    const getIncidentReportCsv = async (variables: GetincidentReportsCsvMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultGetIncidentReportCsvOptions,
                ...options,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        getIncidentReportCsv
    };
};
